module.exports = __webpack_public_path__ + "fonts/lato-blackitalic-webfont.68a6e334.ttf";